<template>
    <section class="hero" aria-labelledby="hero-title">
        <div class="hero__photograph" aria-hidden="true"></div>
        <div class="hero__overlay" aria-hidden="true"></div>
        <div class="pbb-container hero__content">
            <div class="hero__copy">
                <img
                    class="hero__brand"
                    src="@/assets/logo-pbb-white.png"
                    width="837"
                    height="483"
                    alt="Paoli Balbino & Balbino Administração Judicial"
                />
                <span class="hero__eyebrow">Administração judicial</span>
                <h1 id="hero-title">
                    Independência na atuação.<br /><em>Transparência em cada etapa.</em>
                </h1>
                <p>
                    Atuamos para aproximar devedores e credores e dar clareza à condução dos
                    processos.
                </p>
                <router-link to="/#institucional" class="hero__link pbb-focus">
                    <span>Conheça a PB&amp;B</span>
                    <v-icon size="20" aria-hidden="true">mdi-arrow-down</v-icon>
                </router-link>
            </div>
        </div>
    </section>
</template>

<script>
export default { name: 'HeroSection' };
</script>

<style scoped lang="scss">
.hero {
    position: relative;
    isolation: isolate;
    overflow: hidden;
    background: var(--pbb-navy-deep);
    color: #fff;
}
.hero__photograph,
.hero__overlay {
    position: absolute;
    inset: 0;
    pointer-events: none;
}
.hero__photograph {
    inset: -2%;
    // Photograph from the original PB&B website; keep the institutional reference.
    background: url('~@/assets/hero-institutional-building.jpg') center / cover no-repeat;
    animation: hero-ambient 26s ease-in-out infinite alternate;
    will-change: transform;
}
.hero__overlay {
    background: linear-gradient(
        180deg,
        rgba(0, 22, 39, 0.85) 0%,
        rgba(0, 25, 44, 0.67) 40%,
        rgba(0, 22, 39, 0.75) 76%,
        rgba(0, 22, 39, 0.94) 100%
    );
}
.hero__content {
    position: relative;
    display: grid;
    place-items: center;
    min-height: max(720px, 100vh);
    min-height: max(720px, 100svh);
    padding-top: 136px;
    padding-bottom: 84px;
}
.hero__copy {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    text-align: center;
    animation: hero-enter 900ms 100ms ease-out both;
}
.hero__brand {
    display: block;
    width: min(280px, 70%);
    height: auto;
}
.hero__eyebrow {
    margin-top: 36px;
    color: #e1a575;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.22em;
    text-transform: uppercase;
}
.hero h1 {
    max-width: 900px;
    margin: 22px 0 20px;
    font: 300 clamp(30px, 3.3vw, 46px) / 1.25 'Plus Jakarta Sans', sans-serif;
    letter-spacing: -0.035em;
}
.hero h1 em {
    color: #e1b28c;
    font-style: normal;
    font-weight: 400;
}
.hero__copy p {
    max-width: 540px;
    margin: 0;
    color: rgba(255, 255, 255, 0.75);
    font-size: 15px;
    line-height: 1.85;
    text-align: center;
}
.hero .hero__link {
    display: inline-flex;
    align-items: center;
    gap: 14px;
    min-height: 44px;
    margin-top: 34px;
    color: #fff;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-decoration: none;
}
.hero__link .v-icon {
    color: #e1a575;
    transition: transform 200ms ease;
}
.hero__link:hover .v-icon {
    transform: translateY(4px);
}
.hero__link:hover > span,
.hero__link:focus-visible > span {
    text-decoration: underline;
    text-underline-offset: 5px;
}
@keyframes hero-ambient {
    from {
        transform: scale(1.015) translate3d(-0.4%, 0, 0);
    }
    to {
        transform: scale(1.065) translate3d(0.4%, -0.5%, 0);
    }
}
@keyframes hero-enter {
    from {
        opacity: 0;
        transform: translateY(16px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}
@media (max-width: 760px) {
    .hero__content {
        min-height: max(650px, 100svh);
        padding-top: 128px;
        padding-bottom: 68px;
    }
    .hero__photograph {
        background-position: 47% center;
    }
    .hero__brand {
        width: min(220px, 70%);
    }
    .hero__eyebrow {
        margin-top: 30px;
        font-size: 9px;
        letter-spacing: 0.18em;
    }
    .hero h1 {
        max-width: 500px;
        font-size: clamp(27px, 6.2vw, 36px);
        line-height: 1.3;
    }
    .hero__copy p {
        max-width: 380px;
        font-size: 14px;
        padding: 0 10px;
    }
    .hero__link {
        margin-top: 28px;
    }
}
@media (prefers-reduced-motion: reduce) {
    .hero__photograph,
    .hero__copy {
        animation: none;
        will-change: auto;
    }
    .hero__link .v-icon {
        transition: none;
    }
    .hero__link:hover .v-icon {
        transform: none;
    }
}
</style>
